import * as React from "react"
import Layout from "../components/layout"
import Slider from "react-slick"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import { GUIDES } from "../data/guides"

const PrevArrow = ({ onClick }) => (
    <span className="arrow-prv slick-arrow" onClick={onClick} role="button" tabIndex={0} aria-label="Previous slide">
        <i className="icon-chevron-left"></i>
    </span>
);

const NextArrow = ({ onClick }) => (
    <span className="arrow-next slick-arrow" onClick={onClick} role="button" tabIndex={0} aria-label="Next slide">
        <i className="icon-chevron-right"></i>
    </span>
);

const seo = {
    title: "Soundproof phone booths and meeting pods for open-plan offices",
    description: "Vibra One is a soundproof office phone booth with light, ventilation and power built in. A quiet place to focus and take calls, without building walls. Delivered across the UK and the EU.",
}

const Index = ({ data }) => {

    const sliderSettings = {
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
    };

    return (
        <Layout seo={seo}>

            <div className="site-wrapper-reveal">
                <Slider {...sliderSettings} className="hero-area hero-slider-five-later slick-initialized slick-slider">
                    <div className="single-hero-slider-five">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="hero-content-wrap">
                                        <div className="hero-text-five mt-lg-5">
                                            <h5 className=" mb-30 small-title">
                                                VIBRA
                                                <br />
                                                ONE
                                            </h5>
                                            <h1>A quiet room
                                                <br />
                                                without the building work</h1>

                                            <div className="button-box section-space--mt_60">
                                                <Link to="/vibra-one/" className="text-btn-normal font-weight--reguler font-lg-p">Explore Vibra One <i className="icon-arrow-right"></i></Link>
                                            </div>
                                        </div>
                                        <div className="inner-images" >
                                            <div className="image-one">
                                                <Img fluid={data.circleOne.childImageSharp.fluid} placeholderClassName="img-fluid" alt=""></Img>
                                            </div>
                                            <div className="image-two">
                                                <Img fluid={data.bannerFirstImage.childImageSharp.fluid} className="img-fluid" alt="Vibra One soundproof phone booth"></Img>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>

            <div className="banner-area-box">
                <div className="container">
                    <div className="row banner-inner-box">
                        <div className="col-lg-6 col-md-6">
                            <div className="banner-images-one mt-30">
                                <Link to="/vibra-one/" className="thumbnail">
                                    <Img fluid={data.vibraOneSmallBanner.childImageSharp.fluid} alt="Vibra One phone booth in an open-plan office"></Img>
                                </Link>
                                <div className="banner-title">
                                    <h3><Link to="/vibra-one/">Vibra One</Link></h3>
                                    <h6>One-person soundproof booth for calls and focused work</h6>
                                    <div className="button-box mt-40">
                                        <Link to="/vibra-one/" className="text-btn-normal">See the details <i className="icon-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="banner-images-one mt-30">
                                <div className="thumbnail">
                                    <Img fluid={data.vibraFourSmallBanner.childImageSharp.fluid} alt="Vibra Four meeting pod, made to order"></Img>
                                </div>
                                <div className="banner-title">
                                    <h3><Link to="/products/">Vibra Four</Link></h3>
                                    <h6>Meeting pod for up to four people, <br /> built to your requirements</h6>
                                    <div className="button-box mt-40">
                                        <Link to="/contact-us/" className="text-btn-normal">Tell us what you need <i className="icon-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-us-area section-space--ptb_120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <div className="about-us-content_6 text-center">
                                <h5>Open-plan offices are good for teams and hard on concentration. Vibra One gives every desk a quiet room within a few steps: take the call, finish the thought, join the video meeting, and be back with the team in minutes.
                                    <br /><br />
                                    We build private spaces that still feel open. Glass, natural light and fresh air mean nobody has to choose between quiet and comfort.
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="featuted-product-wrap section-space--pb_120 home-guides">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto">
                            <h3 className="section-title text-center">Before you buy a booth</h3>
                            <p className="text-center section-space--mt_20" style={{ color: '#666' }}>
                                Practical guides on the questions that come up before an order.
                            </p>
                            <div className="section-space--mt_40">
                                {GUIDES.map((g) => (
                                    <Link to={`/guides/${g.slug}/`} className="guide-card" key={g.slug}>
                                        <h3>{g.title}</h3>
                                        <p>{g.excerpt}</p>
                                    </Link>
                                ))}
                            </div>
                            <div className="button-box text-center section-space--mt_40">
                                <Link to="/guides/" className="text-btn-normal">All guides <i className="icon-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Layout>
    )
};

export const query = graphql`
  query {
    vibraOneSmallBanner: file(relativePath: { eq: "home/vibra-one-banner-s.jpg" }){
        childImageSharp {
            fluid(maxWidth: 570, maxHeight: 340) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    vibraFourSmallBanner: file(relativePath: { eq: "home/vibra-four-banner-s.jpg" }){
        childImageSharp {
            fluid(maxWidth: 570, maxHeight: 340) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    bannerFirstImage: file(relativePath: { eq: "hero/VIBRA-ONE-banner.png" }){
        childImageSharp {
            fluid(maxWidth: 320) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    circleOne: file(relativePath: { eq: "hero/home-full-width-3a.png"}){
        childImageSharp {
            fluid(maxWidth: 480) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
  }`

export default Index
